import { render } from "./Home.vue?vue&type=template&id=5ebb0d2e"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script